import { treaty } from "@elysiajs/eden";
import type { App } from "@open-booking/server";
import { env } from "@/src/common/constants/env";

const SAFE_METHODS = new Set(["GET", "HEAD", "OPTIONS"]);

let csrfTokenProvider: () => string | null = () => null;

export const registerCsrfTokenProvider = (provider: () => string | null) => {
	csrfTokenProvider = provider;
};

const customFetch: typeof fetch = (input, init) => {
	const method = (init?.method ?? "GET").toUpperCase();
	const headers = new Headers(init?.headers);

	if (!SAFE_METHODS.has(method)) {
		const token = csrfTokenProvider();
		if (token) headers.set("X-CSRF-Token", token);
	}

	return fetch(input, { ...init, headers, credentials: "include" });
};

export const httpClient = treaty<App>(env.SERVER_URL, {
	fetch: { credentials: "include" },
	fetcher: customFetch,
	onResponse: async (response) => {
		if (response.status === 422) {
			const data = await response.json();
			throw new Error(data.message);
		}
	},
});
